
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// CSS
require("@rails/ujs").start()
//require("turbolinks").start()
require("@rails/activestorage").start()
import 'scss/application'
// JS
import('js/site')
import './datepicker'

// Images
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
import NextArrowWhite from "../images/icons/arrow-white-next.png"
import PrevArrowWhite from "../images/icons/arrow-white-prev.png"
import NextArrowBlue from "../images/icons/arrow-blue-next.png"
import PrevArrowBlue from "../images/icons/arrow-blue-prev.png"
import NextArrowSVG from "../images/icons/Izquierda.svg"
import PrevArrowSVG from "../images/icons/Derecha.svg"
require('readmore-js');
import { tinyMce } from "../vendor/tinyMce";
import 'lightgallery'
import 'lg-video'
import 'lg-thumbnail'
import 'lg-zoom'
import mixitup from 'mixitup';

global.toastr = require("toastr")

document.addEventListener("DOMContentLoaded",
function(){
var containerEl = document.querySelector('.container-events');
var mixer;

if (containerEl) {
  mixer = mixitup(containerEl,{
    "animation": {
      "duration": 250,
      "nudge": false,
      "reverseOut": false,
      "effects": "fade"
    }
  });
}

var mixerGallery = mixitup('#gallery', {
  animation: {
    duration: 250,
    nudge: false,
    reverseOut: false,
    effects: 'fade'
  }
});

document.querySelectorAll('.btn-filter').forEach(button => {
  button.addEventListener('click', function(event) {
      event.preventDefault();

      document.querySelectorAll('.btn-filter').forEach(btn => {
          btn.classList.remove('active');
      });

      this.classList.add('active');

      var filterValue = this.getAttribute('data-filter');
      mixerGallery.filter(filterValue);
  });
});


  import("booking").then( booking => {
  })

  $('#expandir_about_home').readmore(
    {
      speed: 75,
      moreLink:'<div class="text-center"><a class="btn btn-flat-down read-more readmore_class boton center-block text-dark bold" style="cursor:pointer;">Read more</a></div>',
      lessLink: '<div class="text-center"><a href="#" class="btn btn-flat-down read-more readless_class boton center-block text-dark bold">Read less</a></div>',
      collapsedHeight: 100
    }
  );

  $('#expandir_readmore_content').readmore(
    {
      speed: 75,
      moreLink:'<div class="text-center"><a class="btn btn-flat-down read-more readmore_class boton center-block text-dark bold" style="cursor:pointer;">Read more</a></div>',
      lessLink: '<div class="text-center"><a href="#" class="btn btn-flat-down read-more readless_class boton center-block text-dark bold">Read less</a></div>',
      collapsedHeight: 100
    }
  );

  tinyMce();
});


$(document).ready(function() {


  function checkScreenSize() {
    if ($(window).width() > 768) {

      $('head').append(`
        <style id="desktop-styles">
          .slider-nav {
            .slick-track {
              width: auto !important;
              transform: none !important;
            }
          }
        </style>
      `);
    } else {

      $('#desktop-styles').remove();
    }
  }
  checkScreenSize();
  $(window).resize(function() {
    checkScreenSize();
  });

  import("slider").then(slick => {

    $('.horizontal-slider-for').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        asNavFor: '.vertical-slider-menu',
        prevArrow:`<div class="icon-prev-arrow"><img src=${PrevArrowWhite} alt="Prev Arrow" /></div>`,
        nextArrow:`<div class="icon-next-arrow"><img src=${NextArrowWhite} alt="Next Arrow" /></div>`,
         dots:false,
         arrows:true,
        responsive: [
          {
            breakpoint:769,
            settings:{
              dots: true,
              arrows:false
            }
          }
        ]
      })
      $('.vertical-slider-menu').on('click', '.slick-slide', function (e) {
        var $currTarget = $(e.currentTarget),
            index = $currTarget.data('slick-index'),
            slickObj = $('.horizontal-slider-for').slick('getSlick');
            slickObj.slickGoTo(index);

        });
        $('.suites-menu').on('click', '.slick-slide', function (e) {
          var $currTarget = $(e.currentTarget),
              index = $currTarget.data('slick-index'),
              slickObj = $('.suites-for').slick('getSlick');
              slickObj.slickGoTo(index);
          });


        $('.suites-for').not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 1,
          fade: true,
          cssEase: 'linear',
          asNavFor: '.suites-menu',
          dots:false,
          arrows:false,
          adaptiveHeight: true,
          swipe: false,
        })
        $('.suites-menu').not('.slick-initialized').slick({
          slidesToShow: 10,
          slidesToScroll: 10,
          infinite: false,
          asNavFor: '.suites-for',
          arrows:false,
          draggable: false,
          responsive: [
            {
              breakpoint:769,
              settings:{
                slidesToShow:1,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                focusOnSelect: true,
                arrows:true,
                infinite:true,
                swipe: false,
                prevArrow:`<div class="slick-prev slick-arrow"><img src=${PrevArrowBlue} alt="Prev Arrow" /></div>`,
                nextArrow:`<div class="slick-next slick-arrow"><img src=${NextArrowBlue} alt="Next Arrow" /></div>`,

              }
            }
          ]

        });

      $('.vertical-slider-menu').not('.slick-initialized').slick({
        slidesToShow: 12,
        infinite: false,
        vertical: true,
        asNavFor: '.horizontal-slider-for',
        arrows:false,
        responsive: [
          {
            breakpoint:769,
            settings:{
              slidesToShow:12,
              adaptiveHeight: true,
              dots: true,
            }
          }
        ]

      });

      $('.dining-for').not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 1,
        asNavFor: '.dining-slider',
         dots:false,
         arrows:false,
         adaptiveHeight: true,
         responsive: [
          {
            breakpoint:769,
            settings:{
              slidesToShow:1,
              slidesToScroll: 1,
              swipe: true,
              arrows:false,
              infinite:true
            }
          }
        ]
      })
      $('.dining-slider').on('click', '.slick-slide', function (e) {
        var $currTarget = $(e.currentTarget),
            index = $currTarget.data('slick-index'),
            slickObj = $('.dining-for').slick('getSlick');
            slickObj.slickGoTo(index);

        });
      $('.dining-slider').not('.slick-initialized').slick({
        slidesToShow: 4,
        asNavFor: '.dining-for',
        arrows:false,
        infinite:false,
        swipe: false,
        responsive: [
          {
            breakpoint:769,
            settings:{
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: '.dining-for',
              dots: false,
              centerMode: true,
              focusOnSelect: true,
              arrows:true,
              infinite:true,
              prevArrow:`<div class="slick-prev slick-arrow"><img src=${PrevArrowBlue} alt="Prev Arrow" /></div>`,
              nextArrow:`<div class="slick-next slick-arrow"><img src=${NextArrowBlue} alt="Next Arrow" /></div>`,
            }
          }
        ]

      })

      $('.general-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        arrows:true,
        infinite:true,
        prevArrow:`<div class="icon-prev-arrow"><img src=${PrevArrowWhite} alt="Prev Arrow" /></div>`,
        nextArrow:`<div class="icon-next-arrow"><img src=${NextArrowWhite} alt="Next Arrow" /></div>`,
        dots:false,
        responsive: [
          {
            breakpoint:769,
            settings:{
              slidesToShow:1,
              dots:true,
              arrows:false,
            }
          }
        ]

      })
      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.slider-nav'
      });

      $('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        infinite: false,
        arrows: false,
        centerMode: true,
        cssEase: 'ease',
        speed: 300,  // Velocidad de desplazamiento para que sea visible
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              swipe: true,
              touchMove: true,
              draggable: true,
              focusOnSelect: true,
              variableWidth: false,
              adaptiveHeight: true,
              speed: 300,  // Velocidad de animación para mobile
              centerMode: false, // Desactivamos centerMode para mobile
              cssEase: 'ease', // Animación suave en mobile
            }
          }
        ]
      });

      $(".carousel-suites-interna").slick({
        slidesToShow: 3, // Muestra 3 cards
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
        prevArrow:`<div class="arrow-suite-prev"><img src=${PrevArrowSVG} alt="Prev Arrow" /></div>`,
        nextArrow:`<div class="arrow-suite-next"><img src=${NextArrowSVG} alt="Next Arrow" /></div>`,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1024, // Tablets
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 600, // Móviles
            settings: { slidesToShow: 1 }
          }
        ]
      });

      $(".carousel-tours").slick({
        slidesToShow: 1, // Muestra 1 card
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow:`<div class="arrow-suite-next"><img src=${NextArrowSVG} alt="Next Arrow" /></div>`,
        nextArrow:`<div class="arrow-suite-prev"><img src=${PrevArrowSVG} alt="Prev Arrow" /></div>`,
        autoplay: false,
      });

      $(".carousel-tours-land").slick({
        slidesToShow: 1, // Muestra 1 card
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow:`<div class="arrow-suite-next"><img src=${NextArrowSVG} alt="Next Arrow" /></div>`,
        nextArrow:`<div class="arrow-suite-prev"><img src=${PrevArrowSVG} alt="Prev Arrow" /></div>`,
        autoplay: false,
      });

      $(".carousel-tours-helicopter").slick({
        slidesToShow: 1, // Muestra 1 card
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow:`<div class="arrow-suite-next"><img src=${NextArrowSVG} alt="Next Arrow" /></div>`,
        nextArrow:`<div class="arrow-suite-prev"><img src=${PrevArrowSVG} alt="Prev Arrow" /></div>`,
        autoplay: false,
      });
  })

  $("#events-grid").lightGallery({
    mode: 'lg-fade',
    thumbnail: false,
    selector: 'a.event-photo',
    loop: false
  });

  $("#my_nanogallery2").lightGallery({
    mode: 'lg-fade',
    thumbnail: false,
    loop:false
  });
  $(".floor-galler").lightGallery({
    thumbnail:true,
    mode: 'lg-fade'
  });
})

// Mostrar selects de edad por cada niño seleccionado en el formulario de tours
document.addEventListener('DOMContentLoaded', function() {
  var kidsSelect = document.getElementById('tours-kids-number');
  var kidsBoxes = document.querySelector('[data-kids-target="kidsBoxes"]');
  if (kidsSelect && kidsBoxes) {
    kidsSelect.addEventListener('change', function() {
      var value = parseInt(this.value);
      kidsBoxes.innerHTML = '';
      if (!isNaN(value) && value > 0) {
        for (var i = 1; i <= value; i++) {
          var select = document.createElement('select');
          select.name = `tours[kid_age_${i}]`;
          select.className = 'form-select custom-select mb-2 col';
          var defaultOption = document.createElement('option');
          defaultOption.value = '';
          defaultOption.text = `Kid Age ${i}`;
          select.appendChild(defaultOption);
          for (var age = 1; age <= 12; age++) {
            var option = document.createElement('option');
            option.value = age;
            option.text = age;
            select.appendChild(option);
          }
          kidsBoxes.appendChild(select);
        }
      }
    });
  }
});




require("trix")
require("@rails/actiontext")




